import { configMgr } from '@nab/nab-x-sdk-browser';
import {
    AppConfigs,
    ConfigKey,
    generateConfigOverrides,
    launch,
    ONOPattern,
    registerLocalPages,
    ShellDataManager
} from '@usl/usl-base-web-shell';
import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';

import { LogoComponent } from './components/LogoComponent';
import { AUTH_CLIENT_ID } from './constants';
import { getWLOverridingConfig } from './overrides/OverridingConfig';

export function Shell() {
    const ref = useRef<HTMLDivElement>(null);
    const [isLaunched, setIsLaunched] = useState(false);

    const initRuntime = useCallback(async () => {
        if (!ref.current) return;

        // Initialize configMgr and AppConfigs (safe to call multiple times - they're singletons)
        await configMgr.init();
        const appConfigs = AppConfigs.getInstance(configMgr);
        appConfigs.setConfigOverrides(generateConfigOverrides(configMgr, AUTH_CLIENT_ID));

        // Only launch the shell once
        if (!isLaunched) {
            await launch(
                ref.current,
                getWLOverridingConfig(
                    appConfigs as any,
                    appConfigs.get(ConfigKey.ONO_PATTERN, 'pattern1') as ONOPattern
                ),
                <LogoComponent />
            );
            await registerLocalPages();
            ShellDataManager.getInstance().syncStorage();
            setIsLaunched(true);
        }
    }, [ref]);

    useLayoutEffect(() => {
        initRuntime();
    }, [initRuntime]);

    return (
        <div>
            <main ref={ref} />
        </div>
    );
}
